<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section">
        <el-form
          label-width="50px"
          label-position="right"
          inline
          style="height:100%"
        >
          <el-form-item :label="$t('Menu.Search')">
            <el-input v-model="txtSearch" :placeholder="$t('Menu.PleaseEnterChinese')" style="width:200px" @change="searchHandler" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 5px" @click="addMenuClickEvent">{{ $t('Menu.AddMenu') }}</el-button>
            <el-button type="primary" style="margin-left: 5px" @click="editMenuClickEvent">{{ $t('Menu.UpdateMenu') }}</el-button>
            <el-button type="primary" style="margin-left: 5px" @click="addTenantMenuClickEvent">{{ $t('Menu.AddCustomerMenu') }}</el-button>
            <el-button type="primary" style="margin-left: 5px" @click="btnRefreshClickEvent">{{ $t('Menu.Refresh') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
    </div>
    <sys-menu-window
      :visible="sysMenuWindow.visible"
      :title="sysMenuWindow.title"
      :sys-menu="sysMenuWindow.sysMenu"
      @saveCallBack="sysMenuWindow.saveCallBack"
      @close="sysMenuWindow.visible=false"
    />
    <sys-menu-by-add-tenant-window
      :visible="tenantWindow.visible"
      :menus="tenantWindow.menus"
      @close="tenantWindow.visible=false"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected } from '@/utils/agGrid'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import SysMenuWindow from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/SysMenuWindow'
import SysMenuByAddTenantWindow from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/SysMenuByAddTenantWindow'
import * as sysMenuApi from '@/api/menu'
import pinyin from 'js-pinyin'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'SysMenuView',
  components: { cargoAdvanceSelect, SysMenuWindow, SysMenuByAddTenantWindow },
  data() {
    return {
      isEdit: false,
      txtSearch: '',
      documentManage: new DocumentManage(),
      selectTypeNames: TYPE_NAMES,
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Menu.ChineseName'),
          colId: 'chineseLabel',
          field: 'chineseLabel',
          width: 240,
          headerCheckboxSelection: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              return params.value
            }
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        // {
        //   headerName: '',
        //   checkboxSelection: true,
        //   width: 55,
        //   pinned: 'left',
        //   sortable: false,
        //   suppressMenu: true,
        //   suppressSizeToFit: true,
        //   resizable: false,
        //   headerCheckboxSelection: true
        // },
        // {
        //   headerName: this.$t('Menu.ChineseName'),
        //   field: 'chineseLabel',
        //   width: 150
        // },
        {
          headerName: this.$t('Menu.EnglishName'),
          field: 'englishLabel',
          width: 150
        },
        {
          headerName: this.$t('Menu.Coding'),
          field: 'code',
          width: 150
        },
        {
          headerName: this.$t('Menu.Icon'),
          field: 'icon',
          width: 150
        },
        {
          headerName: this.$t('Menu.Node'),
          field: 'menuId',
          width: 150
        },
        {
          headerName: this.$t('Menu.ParentNode'),
          field: 'parentId',
          width: 150
        },
        {
          headerName: this.$t('Menu.Order'),
          field: 'orderIndex',
          width: 150,
          sort: 'asc'
        },
        {
          headerName: this.$t('Menu.ModuleFile'),
          field: 'actions',
          width: 150
        },
        {
          headerName: this.$t('Menu.H5Url'),
          field: 'url',
          width: 150
        },
        {
          headerName: this.$t('Menu.IsH5Open'),
          field: 'openH5Url',
          width: 150,
          cellRenderer: params => {
            const checkBoxClickHandler = this.documentManage.getPath('checkBoxClickHandler')
            return `<input id="'${params.data.uuid}'" type="checkbox" ${params.value ? `checked="checked"` : ``} onclick="${checkBoxClickHandler}('${params.data.uuid}')" />`
          }
        }
      ],
      rowData: [],
      sourceData: [],
      PROPERTY_CUSTOMER_ID: null,
      CONDITION_ALL: null,
      subscribePortPushRule: null,
      subscribePortPush: null,
      pushRules: [],
      customers: [],
      ruleViewVisible: false,
      sysMenuWindow: {
        visible: false,
        title: '',
        sysMenu: {},
        saveCallBack: () => {}
      },
      tenantWindow: {
        visible: false,
        title: '',
        menus: [],
        saveCallBack: () => {}
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('checkBoxClickHandler', function(uid) {
      context.checkBoxClickHandler(uid)
    })
  },
  async created() {
    this.initializeHandler()
  },
  methods: {
    initializeHandler() {
      const loading = getLoading()
      sysMenuApi.queryAllMenus().then(resp => {
        const rowData = resp.data
        this.addTreePath(rowData)
        this.sourceData = rowData
        this.rowData = rowData
      }).finally(() => loading.close())
    },
    searchHandler() {
      if (!this.sourceData || this.sourceData.length === 0) {
        return
      }
      if (this.txtSearch) {
        const rowData = this.sourceData.filter(menu => this.menusFilter(menu))
        // 记录父级id
        const pidArr = rowData.map(row => row.parentId)
        // 找出父级
        const pArr = this.sourceData.filter(menu => pidArr.includes(menu.menuId))
        this.rowData = [...rowData, ...pArr]
      } else {
        this.rowData = this.sourceData
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    menusFilter(item) {
      const inputValue = this.txtSearch.trim()
      if (item.chineseLabel) {
        if (item.chineseLabel.toLowerCase().indexOf(inputValue) > -1) { return true }
        if (pinyin.getCamelChars(item.chineseLabel).toLowerCase().indexOf(inputValue) > -1) { return true }
      }

      if (item.englishLabel && item.englishLabel.toLowerCase().indexOf(inputValue) > -1) { return true }

      if (item.code && item.code.toLowerCase().indexOf(inputValue) > -1) { return true }

      if (item.actions && item.actions.toLowerCase().indexOf(inputValue) > -1) { return true }
      return false
    },
    // 添加菜单
    addMenuClickEvent() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      const menu = {}
      menu.type = 2
      menu.parentId = selectedRow ? selectedRow.menuId : 0
      this.sysMenuWindow.title = this.$t('Menu.AddMenu')
      this.sysMenuWindow.sysMenu = menu
      this.sysMenuWindow.saveCallBack = this.saveAddCallBackHandler
      this.sysMenuWindow.visible = true
    },
    saveAddCallBackHandler(menu) {
      this.addTreePath(this.sourceData, menu)
      this.rowData = this.sourceData
      this.gridOptions.api.refreshCells({ force: true })
    },
    // 编辑菜单
    async editMenuClickEvent() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('Menu.PleaseSelectTheMenu'))
        return
      }
      const sysMenu = await sysMenuApi.queryByUuid({ uuid: selectedRow.uuid }).then(resp => resp.data)
      this.sysMenuWindow.title = this.$t('Menu.UpdateMenu')
      this.sysMenuWindow.sysMenu = sysMenu
      this.sysMenuWindow.saveCallBack = this.saveEditCallBackHandler
      this.sysMenuWindow.visible = true
    },
    saveEditCallBackHandler(menu) {
      this.addTreePath(this.sourceData, menu)
      this.rowData = this.sourceData
      this.gridOptions.api.refreshCells({ force: true })
    },
    // 添加客户菜单
    addTenantMenuClickEvent() {
      const items = this.gridOptions.api.getSelectedRows()
      if (items.length === 0) {
        this.$message.warning(this.$t('Menu.PleaseSelectTheMenu'))
        return
      }
      this.tenantWindow.menus = items
      this.tenantWindow.visible = true
    },
    // 刷新列表
    btnRefreshClickEvent() {
      this.initializeHandler()
    },
    // 添加树形路径
    addTreePath(menus, menu) {
      const map = new Map()
      menus.forEach(menu => map.set(menu.menuId, menu.uuid))
      // menu有值时，为新增/编辑后的额外处理start
      if (menu) {
        // 已有数据 编辑的
        if (map.has(menu.menuId)) {
          const index = menus.findIndex(m => m.menuId === menu.menuId)
          menus[index] = menu
        } else {
          // 新增的
          menus.push(menu)
        }
      }
      // menu有值时的处理end
      menus.forEach(menu => {
        if (!menu.parentId) {
          menu.path = menu.uuid
        } else {
          menu.path = map.get(menu.parentId) + ',' + menu.uuid
        }
      })
    },
    checkBoxClickHandler(uuid) {
      const menu = this.rowData.find(row => row.uuid === uuid)
      const openH5Url = !menu.openH5Url
      const uuids = []
      uuids.push(menu.uuid)
      // 获取row的子节点
      const childrenUuids = this.rowData.filter(row => row.parentId === menu.menuId).map(row => row.uuid)
      if (childrenUuids && childrenUuids.length > 0) {
        uuids.push(...childrenUuids)
      }
      const loading = getLoading()
      sysMenuApi.updateMenuH5OpenUrl({ uuids: uuids, openH5Url }).then(resp => {
        if (resp.data > 0) {
          this.$message.success('更新成功')
        }
      }).finally(() => loading.close())
    }
  }
}
</script>

<style scoped>

</style>
